import Vue from "vue";
import moment from "moment";
export default Vue.extend({
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Function,
            default: () => { },
        },
        invoiceDetails: {
            type: Array,
            default: [],
        },
        invoice: {
            type: Object,
            default: {},
        },
    },
    computed: {
        invoiceRestructured() {
            if (!this.invoice)
                return [];
            return [
                { header: "Contact", value: this.invoice.customerContactPerson },
                { header: "Total", value: `${this.invoice.totalAmount} kr` },
                {
                    header: "Total incl. VAT",
                    value: `${this.invoice.totalAmountInclVAT} kr`,
                },
                {
                    header: "Currency",
                    value: `${this.invoice.currency}`,
                },
            ];
        },
    },
    methods: {
        closeDialog() {
            this.$emit("close");
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
    },
});
